export default __webpack_public_path__ + "static/programming1-a59efa45c343610b5e071b02f304c46e.png";